import React, { useState, useEffect, useMemo } from 'react';
import {
  Container, Box, Typography, Paper, TextField, Button, Alert, Chip,
} from '@mui/material';
import axios from 'axios';
import SidebarLayout from '../components/SidebarLayout';

const parseLines = (text: string) =>
  text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

const CopyTextManagement = () => {
  const [text, setText] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const lineCount = useMemo(() => parseLines(text).length, [text]);

  const fetchItems = async () => {
    const resp = await axios.get('/api/qqmusic/copy-texts/all');
    if (resp.data.success) {
      const lines = (resp.data.items || []).map((r: { content: string }) => r.content);
      setText(lines.join('\n'));
    }
  };

  useEffect(() => { fetchItems().catch(console.error); }, []);

  const handleSave = async () => {
    const lines = parseLines(text);
    if (lines.length === 0) {
      setMsg('请至少填写一条文案（每行一条）');
      setTimeout(() => setMsg(''), 4000);
      return;
    }
    setLoading(true);
    try {
      const items = lines.map((content, i) => ({
        content,
        enabled: true,
        sort_order: i,
      }));
      await axios.put('/api/qqmusic/copy-texts', { items });
      setMsg(`已保存 ${lines.length} 条文案，插件下次启动时将拉取最新内容`);
      fetchItems();
    } catch (e: any) {
      setMsg(e.response?.data?.message || '保存失败');
    } finally {
      setLoading(false);
      setTimeout(() => setMsg(''), 4000);
    }
  };

  return (
    <SidebarLayout>
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>评论文案管理（后台锁死）</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          每行一条文案，可直接复制粘贴。用户插件端不可编辑，发送时随机抽取。
        </Typography>
        {msg && <Alert severity={msg.includes('失败') || msg.includes('至少') ? 'error' : 'success'} sx={{ mb: 2 }}>{msg}</Alert>}
        <Paper sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
            <Typography variant="subtitle2">文案内容</Typography>
            <Chip label={`共 ${lineCount} 条`} size="small" color={lineCount > 0 ? 'primary' : 'default'} variant="outlined" />
          </Box>
          <TextField
            fullWidth
            multiline
            minRows={12}
            maxRows={24}
            placeholder={'太好听了！\n循环播放中\n支持！\n单曲循环一整天'}
            value={text}
            onChange={(e) => setText(e.target.value)}
            sx={{ '& textarea': { fontFamily: 'inherit', lineHeight: 1.6 } }}
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, mb: 2 }}>
            空行会自动忽略；保存后将覆盖原有全部文案。
          </Typography>
          <Button variant="contained" onClick={handleSave} disabled={loading}>
            保存
          </Button>
        </Paper>
      </Container>
    </SidebarLayout>
  );
};

export default CopyTextManagement;
